import { render, staticRenderFns } from "./dialogBody.vue?vue&type=template&id=e5a94826&scoped=true&"
import script from "./dialogBody.vue?vue&type=script&lang=js&"
export * from "./dialogBody.vue?vue&type=script&lang=js&"
import style0 from "./dialogBody.vue?vue&type=style&index=0&id=e5a94826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a94826",
  null
  
)

export default component.exports